export interface LicenseStateProps {
    state: LicenseStates;
}

export enum LicenseStates {
    'ACTIVE',
    'EXPIRED',
    'INVALID'
}
